import AMapLoader from '@amap/amap-jsapi-loader'
import _ from 'lodash'

const config = {
  key: '69d54442577598efae315e455bf7e8c5',
  securityCode: '9d6125d4a2f60d7074ae75df15f92775'
}
const loaderList = []

function getOrCreateLoader (plugins, version, isReset) {
  let loaderInfo = _.find(loaderList, loaderInfo => {
    if (version !== loaderInfo.version) {
      return false
    }
    return _.difference(plugins, loaderInfo.plugins).length < 1
  })
  if (!loaderInfo) {
    isReset && AMapLoader.reset()
    const loader = AMapLoader.load({ key: config.key, version, plugins })
    loaderInfo = { plugins, version, loader }
  }
  return loaderInfo.loader
}

function setup () {
  if (config.securityCode && !window._AMapSecurityConfig) {
    window._AMapSecurityConfig = { securityJsCode: config.securityCode }
  }
}

function getAMap (plugins, version = '2.0', isReset = true) {
  return getOrCreateLoader(plugins, version, isReset)
}

export { setup, getAMap }
